"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Groups_1 = __importDefault(require("./components/Groups"));

var TableGrouping_meta_1 = require("./TableGrouping.meta");

var mobx_1 = require("mobx");

var Table_1 = __importDefault(require("../Table/Table"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var ToggleState_1 = require("./models/ToggleState");

var TableGrouping =
/** @class */
function (_super) {
  __extends(TableGrouping, _super);

  function TableGrouping(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = TableGrouping_meta_1.TABLE_GROUPING_CATEGORY_KEY;
    _this.componentKey = TableGrouping_meta_1.TABLE_GROUPING_COMPONENT_KEY;
    _this.rows = [];

    _this.loadRows = function (rows) {
      if (rows === void 0) {
        rows = [];
      }

      _this.rows = rows.map(function (row) {
        if (!row._rowKey) {
          row._rowKey = ksys_app_template_1.utils.guid.generateGuid();
        }

        return row;
      });
    };

    _this.loadGroups = function (grouping, rows, parentGroup) {
      var groups = [];

      if (grouping) {
        var key_1 = grouping.key,
            childGrouping = grouping.childGrouping;
        var rowsByGroupingKey = rows.reduce(function (acc, row) {
          var value = row[key_1];

          if (!acc.has(value)) {
            acc.set(value, []);
          }

          if (acc.has(value)) {
            var groupedRows = acc.get(value);

            if (groupedRows) {
              groupedRows.push(row);
            }
          }

          return acc;
        }, new Map());
        var values = Array.from(rowsByGroupingKey.keys());

        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
          var value = values_1[_i];
          var groupedRows = rowsByGroupingKey.get(value);

          if (groupedRows) {
            var group = {
              value: value,
              groupingKey: grouping.key,
              toggleState: grouping.toggle && grouping.toggle.defaultValue || ToggleState_1.ToggleState.expanded,
              parent: parentGroup
            };
            groups.push(group);

            if (childGrouping) {
              group.children = _this.loadGroups(childGrouping, groupedRows, group);
            }
          }
        }
      }

      return groups;
    };

    _this.mergeGroups = function (currentGroups, newGroups, parentGroup) {
      if (currentGroups === void 0) {
        currentGroups = [];
      }

      if (newGroups === void 0) {
        newGroups = [];
      }

      var response = currentGroups;
      var currentGroupsByValue = currentGroups.reduce(function (acc, group) {
        acc.set(group.value, group);
        return acc;
      }, new Map());

      for (var _i = 0, newGroups_1 = newGroups; _i < newGroups_1.length; _i++) {
        var newGroup = newGroups_1[_i];
        var currentGroup = currentGroupsByValue.get(newGroup.value);

        if (currentGroup) {
          _this.mergeGroup(currentGroup, newGroup);
        } else {
          if (parentGroup) {
            newGroup.parent = parentGroup;
          }

          response.push(newGroup);
        }
      }

      return response;
    };

    _this.mergeGroup = function (currentGroup, newGroup) {
      var _a;

      var currentChildrenByValue = (currentGroup.children || []).reduce(function (acc, group) {
        acc.set(group.value, group);
        return acc;
      }, new Map());
      var newChildren = (newGroup.children || []).filter(function (newChild) {
        return !currentChildrenByValue.has(newChild.value);
      });

      if (newChildren && newChildren.length > 0) {
        if (!currentGroup.children) {
          currentGroup.children = [];
        }

        (_a = currentGroup.children).push.apply(_a, newChildren.map(function (newChild) {
          newChild.parent = currentGroup;
          return newChild;
        }));
      }

      var mergedChildren = _this.mergeGroups(currentGroup.children, newGroup.children, currentGroup);

      if (mergedChildren && mergedChildren.length > 0) {
        currentGroup.children = mergedChildren;
      }
    };

    _this.handleToggleChange = function (toggleState) {
      var groups = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        groups[_i - 1] = arguments[_i];
      }

      for (var _a = 0, groups_1 = groups; _a < groups_1.length; _a++) {
        var group = groups_1[_a];
        group.toggleState = toggleState;
      }

      _this.groups = __spreadArrays(_this.groups);
    };

    _this.handleRowSelectionChange = function (value, row) {
      _this.updateRowsSelection(value, [row]);
    };

    _this.handleGroupSelectionChange = function (value, rows) {
      _this.updateRowsSelection(value, rows);
    };

    _this.updateRowsSelection = function (value, rows) {
      var newRows = __spreadArrays(_this.rows);

      var newRowsByRowKey = ksys_app_template_1.utils.collection.pivotCollection(newRows, function (row) {
        return row._rowKey || 'NO_ROW_KEY';
      });

      for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
        var row = rows_1[_i];
        var newRow = newRowsByRowKey[row._rowKey || 'NO_ROW_KEY'];

        if (newRow) {
          newRow._selected = value;
        }
      }

      _this.loadRows(newRows);
    };

    _this.loadRows(props.rows);

    _this.groups = _this.mergeGroups([], _this.loadGroups(_this.grouping, _this.rows));
    return _this;
  }

  TableGrouping.prototype.componentDidUpdate = function (previousProps) {
    if (ksys_app_template_1.utils.json.stringifySafe(previousProps.rows || []) !== ksys_app_template_1.utils.json.stringifySafe(this.props.rows || [])) {
      this.loadRows(this.props.rows);
      var newGroups = this.loadGroups(this.grouping, this.rows);
      this.groups = this.mergeGroups(this.groups, newGroups);
    }
  };

  Object.defineProperty(TableGrouping.prototype, "grouping", {
    get: function get() {
      if (this.props.grouping) {
        var tableProps = this.props.grouping.tableProps || this.tableProps || {};
        tableProps.rowSelectionChange = this.handleRowSelectionChange;
        return __assign(__assign({}, this.props.grouping), {
          tableProps: tableProps,
          onGroupSelectionChange: this.handleGroupSelectionChange,
          toggle: __assign(__assign({}, this.props.grouping.toggle || {}), {
            onToggleChange: this.handleToggleChange
          })
        });
      }

      return undefined;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TableGrouping.prototype, "tableProps", {
    get: function get() {
      return __assign(__assign({}, this.props.tableProps || {}), {
        rows: this.rows
      });
    },
    enumerable: true,
    configurable: true
  });

  TableGrouping.prototype.render = function () {
    var className = this.props.className;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, this.grouping && react_1.default.createElement(Groups_1.default, {
      grouping: this.grouping,
      rows: this.rows,
      groups: this.groups
    }), !this.grouping && react_1.default.createElement(Table_1.default, __assign({}, this.tableProps)));
  };

  __decorate([mobx_1.action], TableGrouping.prototype, "componentDidUpdate", null);

  __decorate([mobx_1.observable.ref], TableGrouping.prototype, "rows", void 0);

  __decorate([mobx_1.action], TableGrouping.prototype, "loadRows", void 0);

  __decorate([mobx_1.observable.ref], TableGrouping.prototype, "groups", void 0);

  __decorate([mobx_1.action], TableGrouping.prototype, "loadGroups", void 0);

  __decorate([mobx_1.action], TableGrouping.prototype, "mergeGroups", void 0);

  __decorate([mobx_1.action], TableGrouping.prototype, "mergeGroup", void 0);

  __decorate([mobx_1.computed], TableGrouping.prototype, "grouping", null);

  __decorate([mobx_1.computed], TableGrouping.prototype, "tableProps", null);

  __decorate([mobx_1.action], TableGrouping.prototype, "handleToggleChange", void 0);

  __decorate([mobx_1.action], TableGrouping.prototype, "handleRowSelectionChange", void 0);

  __decorate([mobx_1.action], TableGrouping.prototype, "handleGroupSelectionChange", void 0);

  __decorate([mobx_1.action], TableGrouping.prototype, "updateRowsSelection", void 0);

  TableGrouping = __decorate([mobx_react_1.observer], TableGrouping);
  return TableGrouping;
}(shared_1.ComponentBase);

exports.TableGrouping = TableGrouping;
exports.default = shared_1.InjectedStyledComponent(TableGrouping, TableGrouping_meta_1.TABLE_GROUPING_CATEGORY_KEY, TableGrouping_meta_1.TABLE_GROUPING_COMPONENT_KEY);